var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"axj_web_index"},[_c('axj_web_top',{on:{"menu-item-change":_vm.handleMenuItemChange}}),_vm._v(" "),_c('axj_web_body',{attrs:{"active-item":_vm.webBodyConf.activeItem}}),_vm._v(" "),_c('axj_web_bottom')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bae3c9c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/axj_web/index.vue
// module id = null
// module chunks = 